module.exports = __webpack_public_path__ + "static/media/shape-bg.7cee22f9.png";